/* eslint-disable import/no-extraneous-dependencies */
import moment from 'moment';
import React, { useState } from 'react';
import { PiCalendarDotsBold } from 'react-icons/pi';
import DatePicker from 'react-datepicker';
import { Col, Row } from 'reactstrap';

const SellerCommissionCalendar = ({ filters, setFilters }) => {
  const [selectedRange, setSelectedRange] = useState({
    ...filters,
  });

  const handleChange = ([newStartDate, newEndDate]) => {
    setSelectedRange({
      ...filters,
      fromDate: newStartDate,
      toDate: newEndDate,
    });
    if (newStartDate && newEndDate)
      setFilters({
        ...filters,
        fromDate: moment(newStartDate).format('YYYY-MM-DD'),
        toDate: moment(newEndDate).format('YYYY-MM-DD'),
      });
  };
  return (
    <Row>
      <Col sm={3}>
        <div className="position-relative mb-2 datepicker-input ">
          <DatePicker
            selected={selectedRange?.startDate}
            startDate={selectedRange?.fromDate}
            endDate={selectedRange?.toDate}
            onChange={handleChange}
            dateFormat="MM/dd/yyyy"
            // showMonthYearPicker
            selectsRange
          />
          <PiCalendarDotsBold className="fw-bold" color="#8F8D8B" size={22} />
        </div>
      </Col>
    </Row>
  );
};

export default SellerCommissionCalendar;
